@if (activeUserStore.canAccessEntityAdder()) {
  @if (!hideEdit) {
    <a
      pButton
      class="p-button-rounded p-button-xs p-button-primary mr-2"
      [icon]="'fas fa-pen'"
      [routerLink]="[{ outlets: { bearbeiten: [item._id] } }]"></a>
  }
  @if (!hideDelete) {
    <button
      pButton
      class="p-button-rounded p-button-xs p-button-danger"
      (click)="confirm.emit(item)"
      [icon]="'fas fa-trash'"></button>
  }
} @else {
  <div class="text-color-secondary flex gap-2 align-items-center font-italic">
    <i class="fas fa-lock"></i> Keine Schreibrechte
  </div>
}
